import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"
import { addNewUser, hideCreateUserModal } from "store/actions"
import validate from "./createUserFormValidation"

const CreateUserModal = ({
  hideCreateUserModal,
  loading,
  addNewUser,
  handleSubmit,
  vendorId,
}) => {
  return (
    <React.Fragment>
      <Row className="mb-3">
        <Col>
          <h5>Add a new user</h5>
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="first_name" component={TextField} label="First Name" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="last_name" component={TextField} label="Last Name" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field name="email" component={TextField} label="Email" />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="password"
            component={TextField}
            label="Password"
            type="password"
          />
        </Col>
      </Row>
      <Row className="my-2">
        <Col>
          <Field
            name="confirm_password"
            component={TextField}
            label="Confirm Password"
            type="password"
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center my-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Create User"
            onClick={handleSubmit(data => {
              addNewUser({ id: false, vendor_id: vendorId, type: 0, ...data })
            })}
            loading={loading}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Back"
            onClick={hideCreateUserModal}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.codes.loading,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  hideCreateUserModal: () => dispatch(hideCreateUserModal()),
  addNewUser: values => dispatch(addNewUser(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.ADD_USER, validate })(CreateUserModal))
